import axios from "../axiosInstance";

export const triggerEmployeeSync = async (employeeId: number): Promise<void> => {
  await axios.post(`/api/private/remote-sync/employees/${employeeId}`);
};
